<template>
  <div v-show="$store.state.ui.page_n == the_n" style="text-align:center;">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      valid: Boolean,
      n: Number
    },
    data () {
      return {
        saw: false,
        uid: this._uid,
      }
    },
    watch: {
      'valid': function (val) {
        const uid = this.uid
        this.$store.commit('ui/setValidate', { uid, valid })
      },
      '$store.state.ui.page_actual': function (p) {
        if (p.uid === this.uid) {
          this.$store.commit('ui/changePageCat', this.category)
        }
      }
    },
    methods: {
      seen () {
        this.saw = true
      }
    },
    computed: {
      isValid () { return this.$attrs.valid },
      the_n () { return this.$attrs.n },
    },
    props: {
      elegible: {
        type: Boolean,
        default: true
      },
      category: Number
    }
  }
</script>
